import type { IconNode } from '../types';

/**
 * @name trees-forest
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtOSA1IDMtMyAzIDMiIC8+CiAgPHBhdGggZD0ibTkgMTAgMy0zIDMgMyIgLz4KICA8cGF0aCBkPSJNMTIgMTJWMiIgLz4KICA8cGF0aCBkPSJtMiAxNSAzLTMgMyAzIiAvPgogIDxwYXRoIGQ9Im0yIDIwIDMtMyAzIDMiIC8+CiAgPHBhdGggZD0iTTUgMjJWMTIiIC8+CiAgPHBhdGggZD0ibTE2IDE1IDMtMyAzIDMiIC8+CiAgPHBhdGggZD0ibTE2IDIwIDMtMyAzIDMiIC8+CiAgPHBhdGggZD0iTTE5IDIyVjEyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/trees-forest
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const treesForest: IconNode = [
  ['path', { d: 'm9 5 3-3 3 3', key: 'l8vdw6' }],
  ['path', { d: 'm9 10 3-3 3 3', key: '11gsxs' }],
  ['path', { d: 'M12 12V2', key: '17ugg4' }],
  ['path', { d: 'm2 15 3-3 3 3', key: 'cw8wr0' }],
  ['path', { d: 'm2 20 3-3 3 3', key: '4zz25m' }],
  ['path', { d: 'M5 22V12', key: '1vsoti' }],
  ['path', { d: 'm16 15 3-3 3 3', key: '1ttpxg' }],
  ['path', { d: 'm16 20 3-3 3 3', key: 'urscfz' }],
  ['path', { d: 'M19 22V12', key: '1efg87' }],
];

export default treesForest;
